import React from 'react';
import Reveal from './Reveal';
import { routeHref } from '../data/siteData';

const CTASection = ({
  eyebrow = 'Export inquiry',
  title,
  text,
  primaryLabel = 'Send Inquiry',
  primaryPath = '/contact',
  secondaryLabel,
  secondaryPath
}) => {
  return (
    <section className="page-section section-rule">
      <div className="container-custom">
        <Reveal>
          <div className="cta-section">
            <div>
              <p className="eyebrow-pill mb-5">{eyebrow}</p>
              <h2>{title}</h2>
              <p>{text}</p>
            </div>
            <div className="cta-actions">
              <a className="btn-primary" href={routeHref(primaryPath)}>{primaryLabel}</a>
              {secondaryLabel && secondaryPath ? (
                <a className="btn-secondary" href={routeHref(secondaryPath)}>{secondaryLabel}</a>
              ) : null}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default CTASection;
